// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 477) return "static/chunks/8479bc39-92f4f578c79b30e0.js";
	if (chunkId === 205) return "static/chunks/205-35dc03b4027ef244.js";
	if (chunkId === 861) return "static/chunks/861-09fd5a9fda9f073c.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"1328a5e2040532bc","311":"38d13e714e240ac4","320":"e58af90aeba6e4fa","340":"aa216037aef90951","367":"021a1c01ad5cf216","713":"296791eb083a3516","748":"6f1bd59fd0e5dc53"}[chunkId] + ".js";
};